import axios from 'axios'

const state = {
  jobUser: null,
  jobSkills: null,
  jobLanguages: null
}

const actions = {
  fetchJobUserDetail: async ({commit}, id) => {
    const url = `/job-users/${id}`
    const res = await axios.get(url)
    if (res.status === 200) {
      const response = res.data
      if (!response.error) {
        commit('SET_JOB_USER_RELATED_DATA', response)
      }
    }
  },
  loginLineJobUser: async ({commit}, submitData) => {
    commit('SET_JOB_USER', null)
    const url = '/line/login-job-user'
    const res = await axios.post(url, submitData)
    if (res.status === 200) {
      const response = res.data
      if (!response.error) {
        commit('SET_JOB_USER', response.job_user)
      }
    }
  },
  loginJobUser: async ({commit}, submitData) => {
    commit('SET_JOB_USER', null)
    const url = '/job-users/login'
    const res = await axios.post(url, submitData)
    if (res.status === 200) {
      const response = res.data
      if (!response.error) {
        commit('SET_JOB_USER', response.job_user)
      }
    }
  },
  updateJobUser: async ({commit}, submitData) => {
    const url = `/job-users/${submitData.id}`
    const res = await axios.put(url, submitData)
    if (res.status === 200) {
      const response = res.data
      if (!response.error) {
        commit('SET_JOB_USER', response.job_user)
      }
    }
  },
  addJobUserJobPost: async ({commit}, submitData) => {
    const url = `/job-users/${submitData.job_user_id}/job-post`
    const res = await axios.post(url, submitData)
    if (res.status === 200) {
      const response = res.data
      console.log('response', response)
    }
  },
  deleteJobUserJobPost: async ({commit}, submitData) => {
    const url = `/job-users/${submitData.job_user_id}/job-post`
    const res = await axios.delete(url, {data: submitData})
    if (res.status === 200) {
      const response = res.data
      console.log('response', response)
    }
  },
  addJobUserJobSkill: async ({commit}, submitData) => {
    const url = `/job-users/${submitData.job_user_id}/job-skill`
    const res = await axios.post(url, submitData)
    if (res.status === 200) {
      const response = res.data
      console.log('response', response)
    }
  },
  deleteJobUserJobSkill: async ({commit}, submitData) => {
    const url = `/job-users/${submitData.job_user_id}/job-skill`
    const res = await axios.delete(url, {data: submitData})
    if (res.status === 200) {
      const response = res.data
      console.log('response', response)
    }
  },
  addJobUserLanguage: async ({commit}, submitData) => {
    const url = `/job-users/${submitData.job_user_id}/language`
    const res = await axios.post(url, submitData)
    if (res.status === 200) {
      const response = res.data
      console.log('response', response)
    }
  },
  deleteJobUserLanguage: async ({commit}, submitData) => {
    const url = `/job-users/${submitData.job_user_id}/language`
    const res = await axios.delete(url, {data: submitData})
    if (res.status === 200) {
      const response = res.data
      console.log('response', response)
    }
  },
  updateProfessionalStatus: async ({commit}, id) => {
    const url = `/job-users/${id}/professional-status`
    const res = await axios.post(url)
    if (res.status === 200) {
      const response = res.data
      console.log('response', response)
    }
  }
}

const mutations = {
  SET_JOB_USER: (state, jobUser) => {
    state.jobUser = (jobUser) ? {...jobUser} : null
  },
  SET_JOB_USER_RELATED_DATA: (state, response) => {
    state.jobUser = {...response.job_user}
    state.jobSkills = response.job_skills
    state.jobLanguages = response.job_languages
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/job.user.js